const initState = {
    fetching: false,
    fetched: false,
    message: null,
    data: null,
    error: null,
    success: null,
    type: null,
    discount: null,
    selected: null
}

const discountReducer = (state = initState, action) => {
    switch (action.type) {
        case 'FETCH_DISCOUNT_PENDING':
            return {
                ...state,
                fetching: true,
                error: null
            }
        case 'FETCH_DISCOUNT_SUCCESS':

            return {
                ...state,
                fetching: false,
                fetched: true,
                data: action.data,
                selected: action.selected,
                success: true,
                type: 'fetch'
            }

        case 'FETCH_DISCOUNT_FAILED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: action.error,
                message: action.error.data.message,
                success: false,
                type: 'fetch'
            }
        case 'SAVE_DISCOUNT_PENDING':
            return {
                ...state,
                fetching: true,
            }
        case 'SAVE_DISCOUNT_SUCCESS':

            return {
                ...state,
                fetching: false,
                fetched: true,
                message: action.message,
                type: 'save',
                success: true
            }

        case 'SAVE_DISCOUNT_FAILED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: action.error,
                message: action.message,
                type: 'save',
                success: false
            }
        case 'GET_DISCOUNT_PENDING':
            return {
                ...state,
                fetching: true,
            }
        case 'GET_DISCOUNT_SUCCESS':

            return {
                ...state,
                fetching: false,
                fetched: true,
                type: 'get',
                discount: action.data,
                success: true
            }

        case 'GET_DISCOUNT_FAILED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: action.error,
                message: action.message,
                type: 'get',
                success: false
            }
        case 'UPDATE_DISCOUNT_PENDING':
            return {
                ...state,
                fetching: true,
            }
        case 'UPDATE_DISCOUNT_SUCCESS':

            return {
                ...state,
                fetching: false,
                fetched: true,
                message: action.message,
                type: 'update',
                success: true
            }

        case 'UPDATE_DISCOUNT_FAILED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: action.error,
                message: action.message,
                type: 'update',
                success: false
            }
        case 'TOGGLE_DISCOUNT_PENDING':
            return {
                ...state,
                // fetching: true,
            }
        case 'TOGGLE_DISCOUNT_SUCCESS':

            return {
                ...state,
                // fetching: false,
                // fetched: true,
                // message: action.message,
                // type: 'toggle',
                // success: true
            }

        case 'TOGGLE_DISCOUNT_FAILED':
            return {
                ...state,
                // fetching: false,
                // fetched: true,
                error: action.error,
                // message: action.message,
                type: 'toggle',
                // success: false
            }
        case 'DELETE_DISCOUNT_PENDING':
            return {
                ...state,
                fetching: true,
            }
        case 'DELETE_DISCOUNT_SUCCESS':

            return {
                ...state,
                fetching: false,
                fetched: true,
                type: 'delete',
                message: action.message,
                success: true
            }

        case 'DELETE_DISCOUNT_FAILED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: action.error,
                message: action.message,
                type: 'delete',
                success: false
            }
        case 'SELECT_DISCOUNT_PENDING':
            return {
                ...state,
                // fetching: true,
            }
        case 'SELECT_DISCOUNT_SUCCESS':

            return {
                ...state,
                selected: action.selected
                // fetching: false,
                // fetched: true,
                // message: action.message,
                // type: 'toggle',
                // success: true
            }

        case 'SELECT_DISCOUNT_FAILED':
            return {
                ...state,
                // fetching: false,
                // fetched: true,
                error: action.error,
                // message: action.message,
                type: 'toggle',
                // success: false
            }
        default:
            return state
    }
}

export default discountReducer